let playing = false;

export function setAudioPlaying(value) {
  playing = value;
  document.body.classList.toggle("audio-locked", value);
}

export function isAudioPlaying() {
  return playing;
}

/** Resolves once no audio is playing/pending. Used to gate screen transitions so the next
 * screen's narration never starts while the previous one is still speaking. */
export function whenAudioIdle() {
  return new Promise((resolve) => {
    const check = () => {
      if (!playing) resolve();
      else setTimeout(check, 150);
    };
    check();
  });
}
